import { styled } from '@mui/material';

export const Wrapper = styled('div')(({ theme: { zIndex } }) => ({
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: zIndex.appBar + 1,
}));
